import { Col } from "./Flexbox";
import DimensionAndTolerance from "./DimensionAndTolerance";
import SubstratumAndInk from "./SubstratumAndInk";
import ProductiveProcess from "./ProductiveProcess";
import ProductionParams from "./ProductionParams";
import Finishes from "./Finishes";
import TechSpecsEnd from "./TechSpecsEnd";

const TechSpecs = ({theme, control}) => {

    return (
        <Col style={{width:'100%'}}>
            <DimensionAndTolerance theme={theme} control={control}/>
            <SubstratumAndInk theme={theme} control={control}/>
            <ProductiveProcess theme={theme} control={control}/>
            <ProductionParams theme={theme} control={control}/>
            <Finishes theme={theme} control={control}/>
            <TechSpecsEnd theme={theme} control={control}/>
        </Col>
    )
}

export default TechSpecs;